export * from "./primitives/colors";
export * from "./primitives/typography";
export * from "./primitives/spacing";
export * from "./primitives/radii";
export * from "./primitives/shadows";
export * from "./primitives/layout";
export * from "./semantic/types";
export * from "./semantic/typography";
export * from "./semantic/spacing";
export * from "./semantic/radii";
export * from "./semantic/shadows";
export * from "./semantic/borders";
export * from "./semantic/layout";
export * from "./semantic/colors";
export * from "./themes/learn";
export * from "./themes/meta";
export * from "./themes/sriChaitanya";

import { learnTheme } from "./themes/learn";
import { metaTheme } from "./themes/meta";
import { sriChaitanyaTheme } from "./themes/sriChaitanya";

export const themes = {
  learn: learnTheme,
  meta: metaTheme,
  sriChaitanya: sriChaitanyaTheme,
} as const;

export * from "./react/ThemeProvider";
export * from "./react/themeDebug";
export * from "./react/HeaderAvatarActionContext";
export {
  getSubjectResumeIconColors,
  getSubjectPaletteBorderColor,
  getTeacherPlaceholderIconColor,
} from "./getSubjectResumeIconColors";
export { getMainScreenChromeGradient } from "./mainScreenChrome";
